import { EOfficeType, Filters } from 'shared/types/filters';

export function isOnlyBusinessCategory(filters: Filters): boolean {
  return filters.officeType.every(type => [EOfficeType.RentalBusiness, EOfficeType.ReadyBusiness].includes(type));
}
